import { render, staticRenderFns } from "./DatasetContactForm.vue?vue&type=template&id=c7f86548&scoped=true"
import script from "./DatasetContactForm.vue?vue&type=script&lang=js"
export * from "./DatasetContactForm.vue?vue&type=script&lang=js"
import style0 from "./DatasetContactForm.vue?vue&type=style&index=0&id=c7f86548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f86548",
  null
  
)

export default component.exports